import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import ScrollToTop from "./components/scroll-to-top/scroll-to-top.component";
import { Header, Footer } from "./components";

ReactDOM.render(
  <Router>
    <ScrollToTop>
      <Header mostrarHeader={true}/>
      <App />
      <Footer />
    </ScrollToTop>
  </Router>,
  document.getElementById("root")
);

serviceWorker.unregister();
